import styled, { css } from "styled-components";
import { ids } from "@icarros/theme-react";
import { hexToRgba } from "@icarros/utils-react";
import { Label } from "../../../Atoms";
const { color, opacity, size, foundation_time, easing } = ids || {};
const hover = css `
  &:hover {
    background: ${hexToRgba(color.action.neutral.ids_color_action_neutral_base, opacity.ids_opacity_soft)};
  }
`;
export const StyledListItemContainer = styled.label `
  display: flex;
  align-items: center;
  width: 100%;
  ${({ variant }) => variant !== "simple" && 'cursor: pointer'};
  min-height: ${({ subLabel, subDescript }) => subLabel || subDescript
    ? size.general.ids_size_general_84x
    : size.general.ids_size_general_64x};
  padding: ${size.general.ids_size_general_20x} 0;
  gap: ${size.general.ids_size_general_16x};
`;
export const StyledListItemActionContainer = styled.button `
  display: flex;
  align-items: center;
  width: 100%;
  min-height: ${({ subLabel, subDescript }) => subLabel || subDescript
    ? size.general.ids_size_general_84x
    : size.general.ids_size_general_64x};
  padding: ${size.general.ids_size_general_20x} 0;
  gap: ${size.general.ids_size_general_16x};
  border: 0 none;
  background: none;
  cursor: pointer;
  ${({ hasHover }) => hasHover && hover}
`;
export const StyledDescription = styled.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`;
export const StyledLabelContainer = styled.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;
export const StyledLabel = styled(Label) `
  text-align: left;
`;
export const StyledDescriptionContainer = styled.div `
  display: flex;
  align-items: center;
  margin-left: auto;
  margin-right: 0;
`;
export const StyledIcons = styled.div `
  padding: ${size.general.ids_size_general_8x}
    ${size.general.ids_size_general_16x};
  &.action-icon {
    padding-right: 0;
    padding-left: ${size.general.ids_size_general_8x};
  }
  &.avatar-icon {
    padding: ${size.general.ids_size_general_8x}
      ${size.general.ids_size_general_4x};
  }
`;
export const AccordionContent = styled.div `
  padding: ${({ variant }) => (variant === "selector") ? 0 : `0 ${size.general.ids_size_general_24x}`};
  overflow: auto;
  width: 100%;
`;
export const StyledListItemAccordionContainer = styled.div `
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;

  .accordion-fade-in-start {
    overflow: hidden;
    max-height: 0;
    padding: 0;
  }

  .accordion-fade-in-moderate-end {
    max-height: 500px;
    transition: all ${foundation_time.moderate.time_moderate_400ms}
      ${easing.expressive.inOut.ids_easing_expressive_standard};
    padding: ${({ variant }) => (variant === "selector") ? 0 : ` ${size.general.ids_size_general_24x} 0 ${size.general.ids_size_general_24x}`};
  }

  .accordion-fade-out-start {
    max-height: 500px;
    padding: ${size.general.ids_size_general_24x} 0 ${size.general.ids_size_general_24x};
  }

  .accordion-fade-out-moderate-end {
    max-height: 0;
    overflow: hidden;
    transition: all ${foundation_time.fast.time_fast_150ms}
      ${easing.expressive.inOut.ids_easing_expressive_standard};
    padding: 0;
  }

  .accordion-icon {
    transition: all ${foundation_time.fast.time_fast_150ms}
      ${easing.expressive.inOut.ids_easing_expressive_standard};
    &.active {
      transform: rotate(-180deg);
    }
  }
`;
//# sourceMappingURL=ListItem.style.js.map